import { Activity } from "./activity.model";

export class ProjectData {
    fundingProjectID: string;
    state: string;
    businessUnit: string;
    projectName: string;
    projectManager: string;
    operatingUnit: string;
    powerPlanProjectType: string;
    majorLocation: string;
    estimatedStartDate: string;
    estimatedInServiceDate: string;
    estimatedCompletionDate: string;
    projectChargeIndicator: string;
    respCenter: string;
    contractAdmin: string;
    assetLocation: string;
    activities: Activity[];
    projectLongDescription: string;
    problemStatement: string;
    proposedObjective: string;
    notes: string;

    constructor() {
        this.fundingProjectID = '';
        this.state = '';
        this.businessUnit = '';
        this.projectName = '';
        this.projectManager = '';
        this.operatingUnit = '';
        this.powerPlanProjectType = '';
        this.majorLocation = '';
        this.estimatedStartDate = '';
        this.estimatedInServiceDate = '';
        this.estimatedCompletionDate = '';
        this.projectChargeIndicator = '';
        this.respCenter = '';
        this.contractAdmin = '';
        this.assetLocation = '';
        this.activities = [];
        this.projectLongDescription = '';
        this.problemStatement = '';
        this.proposedObjective = '';
        this.notes = '';
    }
}